import { useSearchPageMapData } from "@/providers/search";
import { useMap } from "@vis.gl/react-google-maps";
import { Loader2 as LoaderCircleIcon } from "lucide-react";
import React from "react";
import { Marker } from "./marker";

export const Markers = React.memo(function Markers() {
	const map = useMap();
	const markers = useSearchPageMapData(state => state.mapData);
	const hasFirstClientDataLoaded = useSearchPageMapData(state => state.hasFirstClientDataLoaded);

	if (!hasFirstClientDataLoaded) return null;

	if (!map) {
		return (
			<div className="absolute inset-0 flex items-center justify-center bg-white/50 z-10">
				<LoaderCircleIcon className="w-8 h-8 animate-spin text-primary-500" />
				<span className="ml-2 text-gray-600">Initializing map...</span>
			</div>
		);
	}

	return (
		<>
			{markers.map(marker => (
				<Marker key={`marker-${marker._id?.toString()}`} marker={marker} />
			))}
		</>
	);
});
